/* eslint max-classes-per-file: 0 */

import {
  Participant as Data,
  ParticipantCollection as Collection,
} from '@/typings/api/Participant'
import { ParticipantsApi as Api } from '@/api/resources'

import { Fabric } from '@/store/createCrudModule'


const { TransformerParams, Adapter } = Fabric<Data, Collection>()

export class ParticipantsTransformerParams extends TransformerParams {
  protected defaultParams = ['slug', 'topic_slug'];

  protected per_page = 'pageSize';
}

export class ParticipantsAdapter extends Adapter<Api> {
  public readonly api = new Api();

  public readonly transformerParams = new ParticipantsTransformerParams();
}
